import { EAxiosResponseCode, getHttpErrorMessage, Http } from '@core/api';
import { IServerMyProductConfig, IServerMyProductItem } from '../../types/crowd-source/my-product';
import { getHostbaseUrl } from '@core/tools';

const hostUrl = getHostbaseUrl();

/**
 * 服务商 - 我的产品列表
 */
export async function queryMyServerProducts(isCompany: boolean, productType?: number) {
  let data = [] as IServerMyProductItem[];

  try {
    const { code, context, message } = await Http.post<IServerMyProductItem[]>(`${hostUrl}/side/server/product/myList${isCompany ? '/company' : ''}?productType=${productType}`);

    if (code === EAxiosResponseCode.Succeed) {
      data = context || [];
    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return data;
}

/**
 * 服务商 - 产品税费分配
 */
export async function saveAuthProductCompany(params: IServerMyProductConfig) {
  try {
    const { code, message } = await Http.post<void>(`${hostUrl}/side/agent/product/auth/config/company`, params);

    if (code !== EAxiosResponseCode.Succeed) {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }
}

/**
 * 特级代理商 - 我的产品列表
 */
export async function queryMyAgentProducts(productType?: number) {
  let data = [] as IServerMyProductItem[];

  try {
    const { code, context, message } = await Http.post<IServerMyProductItem[]>(`${hostUrl}/side/server/product/myList/agent?productType=${productType}`);

    if (code === EAxiosResponseCode.Succeed) {
      data = context || [];
    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return data;
}

/**
 * 企业 -  撮合我的产品税费分配
 */
export async function saveAuthProductMatch(id: number, serviceAmountBear: 0 | 1) {
  try {
    const { code, message } = await Http.post<void>(`${hostUrl}/side/agent/product/auth/match-company-config`, {
      id,
      serviceAmountBear, 
    });

    if (code !== EAxiosResponseCode.Succeed) {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }
}
